import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=5a003476&scoped=true&"
import script from "./menu-group.vue?vue&type=script&lang=ts&"
export * from "./menu-group.vue?vue&type=script&lang=ts&"
import style0 from "./menu-group.vue?vue&type=style&index=0&id=5a003476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a003476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItemIcon})
